import { useEmailTemplateBuiltins } from 'src/api/rpc/hooks/communications/useEmailTemplates';

/** Sentinel select value for free-form title/message (no template). */
export const CUSTOM_MESSAGE_VALUE = '__custom__';

export type NotifyMessageCategory = 'orders' | 'discounts';

/** Builtin categories the ad-hoc dialog offers, keyed by the group they sit in. */
export const CATEGORY_BY_GROUP: Record<NotifyMessageCategory, string> = {
  orders: 'order_notification',
  discounts: 'discount_notification',
};

/**
 * Default pick for a freshly opened dialog: the first template of the group
 * matching the record, or Custom when there is no record / no template yet.
 */
export function useDefaultNotifyMessageValue(
  category: NotifyMessageCategory | null,
): string {
  const { data: builtinsData } = useEmailTemplateBuiltins();
  if (!category) return CUSTOM_MESSAGE_VALUE;
  const first = (builtinsData?.builtins ?? []).find(
    (b) => b.category === CATEGORY_BY_GROUP[category],
  );
  return first ? `builtin:${first.key}` : CUSTOM_MESSAGE_VALUE;
}
